module.exports = __webpack_public_path__ + "img/home1.e0cdb5a9.jpg";